module.exports = __webpack_public_path__ + "img/roll.1dcca946.jpeg";